module.exports = __webpack_public_path__ + "static/media/empty-folder.7c8e9d0f.svg";